import CrudCustom from '../../../libs/custom/CrudCustom';

let SilkService = new CrudCustom('/data-silk');
export default SilkService;